module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ws-content"
  }, [_c('nav-menu'), _vm._v(" "), _c('div', {
    staticClass: "left-side-arrow",
    on: {
      "click": function($event) {
        return _vm.togglebtn($event)
      }
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.leftSideOpen ? '显示左侧菜单' : '隐藏左侧菜单',
      "placement": "left"
    }
  }, [_c('i', {
    staticClass: "ws-iconfont",
    class: _vm.leftSideOpen ? 'wsicon-menuunfold' : 'wsicon-menufold'
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "page-heading main-heading",
    attrs: {
      "hidden": "hidden"
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.breadCrumbs), function(item, index) {
    return _c('el-breadcrumb-item', [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('keep-alive', [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-side-arrow-top",
    on: {
      "click": function($event) {
        return _vm.toggleTop($event)
      }
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "回到顶部",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-top"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side-arrow-bottom",
    on: {
      "click": function($event) {
        return _vm.toggleBottom($event)
      }
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "回到底部",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-bottom"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-38e716bf!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/framework/content.vue
// module id = 1098
// module chunks = 99